<template>
	<div>
		<v-row>
			<v-col cols="12" md="3">
			</v-col>
			<v-col cols="12" md="6">
				<date-navigator v-model="dateRange">
					<div class="text-center">
						<v-btn color="primary" small dark class="mx-1" @click="loadData">
							دریافت اطلاعات
						</v-btn>
					</div>
				</date-navigator>
			</v-col>
			<v-col cols="12" md="3" class="d-flex align-center justify-end">
				<export-excel :items="items" :headers="headers" :fileName="excelFileName">
				</export-excel>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<span class="ml-2">فیلترها: </span>
				<v-btn-toggle multiple v-model="statusFilter" dense tile outlined color="purple mr-2">
					<v-btn value="Pending" small>
						در انتظار ها
						<v-badge color="warning" :content="items.filter(x => x.statusText == 'Pending').length || '0'" inline>
						</v-badge>
					</v-btn>
					<v-btn value="Delivered" small>
						تحویل شده ها
						<v-badge color="success" :content="items.filter(x => x.statusText == 'Delivered').length || '0'" inline></v-badge>
					</v-btn>
					<v-btn value="Failed" small>
						تحویل نشده ها
						<v-badge color="error" :content="items.filter(x => x.statusText == 'Failed').length || '0'" inline></v-badge>
					</v-btn>
				</v-btn-toggle>
			</v-col>
			<v-col cols="12">
				<v-data-table dense :headers="headers" :loading="loading" :items="filteredItems" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" class="elevation-1">
					<template v-slot:item.smsPanelText="{ item }">
						{{ translateSmsPanel(item.smsPanelText) }}
					</template>
					<template v-slot:item.statusText="{ item }">
						<div class="d-flex align-center" :class="[statusColor(item.statusText) + '--text']">
							<v-icon :color="statusColor(item.statusText)" small inline class="ml-1">
								{{ statusIcon(item.statusText) }}
							</v-icon>
							<span class="text-h6" style="white-space: nowrap;">{{ translateStatus(item.statusText) }}</span>
							<v-btn v-if="item.statusText === 'Pending' && item.smsKey" fab icon x-small @click="refreshStatus(item)" :loading="rowLoading == item.id">
								<v-icon>mdi-refresh</v-icon>
							</v-btn>
						</div>
					</template>
					<template v-slot:item.date_Persian="{ item }">
						<div>{{ item.date_Persian.date }}</div>
						<div>{{ item.date_Persian.time }}</div>
					</template>
					<template v-slot:item.text="{ item }">
						<div @click="showSmsMessage(item.text)" style="max-width:250px;overflow:hidden;cursor:pointer;text-overflow: ellipsis;white-space: nowrap;">
							{{ item.text }}
						</div>
					</template>
					<template v-slot:item.appSmsTypeText="{ item }">
						{{ translateType(item) }}
					</template>
					<template v-slot:item.price="{ item }">
						{{ item.price.toString().toPriceFormat() }}
					</template>
					<template v-slot:item.operations="{ item }">
						<v-btn small @click="resend(item)" :loading="rowLoading == item.id">
							ارسال مجدد
						</v-btn>
					</template>
				</v-data-table>
			</v-col>
		</v-row>

		<v-dialog v-model="smsMessageDialog" max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">متن پیامک</span></div>
					<v-spacer />
					<v-btn @click="smsMessageDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<p style="white-space: pre-wrap;">{{ smsMessage }}</p>
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
import api from '@/util/app-api'
import toast from '@/util/toast'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import { call, get } from 'vuex-pathify'

export default {
	name: 'SmsList',
	props: {
		mobile: { type: String },
		autoLoad: { type: Boolean, default: true },
		area: { type: String, default: '' }
	},
	components: {
		ConfirmDlg: () => import('@/components/Confirm'),
		'date-picker': VuePersianDatetimePicker,
		'date-navigator': () => import('@/components/DateNavigator'),
	},
	data() {
		return {
			errorMessages: '',
			statusFilter: [],
			loading: false,
			rowLoading: '',
			headers: [
				{
					text: 'پنل پیامک',
					align: 'right',
					sortable: true,
					value: 'smsPanelText',
				},
				{
					text: 'وضعیت',
					align: 'center',
					sortable: true,
					value: 'statusText',
				},
				{
					text: 'زمان ارسال',
					align: 'center',
					sortable: true,
					value: 'date_Persian',
				}, {
					text: 'متن',
					align: 'right',
					sortable: true,
					value: 'text',
					width: 200
				}, {
					text: 'دریافت کننده',
					align: 'center',
					sortable: true,
					value: 'to',
				}, {
					text: 'نوع',
					align: 'center',
					sortable: true,
					value: 'appSmsTypeText',
				}, {
					text: 'عملیات',
					align: 'center',
					sortable: false,
					value: 'operations',
				}
			],
			items: [],
			smsMessageDialog: false,
			smsMessage: '',
			dateRange: { start: new Date().toJSON(), end: '' },
			smsPanels: [
				{ id: 1, title: 'جت اقساط' },
				{ id: 2, title: 'ملی پیامک' },
				{ id: 3, title: 'کاوه نگار' },
				{ id: 4, title: 'IPPanel' },
			],
		}
	},
	computed: {
		...get('siteConfig', [
			'isCloud'
		]),
		excelFileName() {
			let name = 'گزارش پیامک ها'
			if (this.dateRange.start)
				name += ' از ' + this.dateRange.start.toString().split('T')[0]
			if (this.dateRange.end)
				name += ' تا ' + this.dateRange.end.toString().split('T')[0]
			name += '.xls'
			return name
		},
		filteredItems() {
			if (!(this.statusFilter || []).length)
				return this.items
			let clonedItems = []
			clonedItems.push(...this.items)
			clonedItems = clonedItems.filter(x => this.statusFilter.indexOf(x.statusText) > -1)
			return clonedItems
		}
	},
	created() {
		if (this.area === 'superadmin') {
			this.headers.splice(0, 0, {
				text: 'مشتری',
				align: 'right',
				sortable: true,
				value: 'customer.name',
			})
		}
		if (this.isCloud) {
			this.headers.push({
				text: 'هزینه',
				align: 'center',
				sortable: true,
				value: 'price',
			})
		}
	},
	mounted() {
		if (this.autoLoad)
			this.loadData()
	},
	methods: {
		loadData() {
			this.loading = true
			api.get(`${this.area}/appsms/list/?start=` + this.dateRange.start + '&end=' + this.dateRange.end + '&mobile=' + (this.mobile ? this.mobile : ''), null)
				.then(
					response => {
						this.items = response
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => {
					this.loading = false
				})
		},

		translateType(item) {
			if (item.appSmsType == 0)
				return item.smsPatternTitle

			let translates = {
				'Unknown': 'متفرقه',
				'DueDate': 'یادآوری سررسید',
				'Thanks': 'تشکر از پرداخت',
				'OverDueDate': 'معوق',
				'BeforeDueDate': 'یادآوری پیش از موعد',
				'ChangeStatus': 'تغییر وضعیت درخواست وام',
				'ChangeAgentStatus': 'تغییر وضعیت نماینده',
				'VerifyCode': 'کد تاییدیه',
				'Login': 'ورود به پنل',
				'Register': 'خوش آمد ثبت نام',
				'WalletCharge': 'شارژ کیف پول',
				'LoginOTP': 'رمز عبور پیامکی',
				'DailyReport': 'گزارش روزانه به مدیر',
				'NewOrder': 'سفارش خرید اقساطی به مدیر',
				'NewUserLoan': 'ثبت پرونده',
				'WalletWithdrawOtp': 'کد تائیدیه برداشت از کیف پول',
				'WalletWithdrawNotification': 'اطلاعیه برداشت از کیف پول',
				'AgentFactorPaymentLink': 'لینک پرداخت صورتحساب الکترونیکی',
				'DigitalSignOtp': 'کد تایید امضای دیجیتال',
				'DigitalSignLink': 'لینک قرارداد',
				'DigitalSignComplete': 'اطلاعیه ثبت موفق قرارداد',
				'NewLoanRequestNotification': 'اطلاعیه درخواست وام جدید'
			}
			return translates[item.appSmsTypeText] || 'نامشخص'
		},
		translateStatus(status) {
			let items = {
				'Pending': 'منتظر وضعیت',
				'Delivered': 'تحویل شده',
				'Failed': 'تحویل نشده',
			}
			return items[status] || 'نامشخص'
		},
		translateSmsPanel(panel) {
			let items = {
				'Unknown': 'نامشخص',
				'JetAqsaat_MelliPayamak': 'جت اقساط',
				'JetAqsaat_KaveNegar': 'جت اقساط',
				'JetAqsaat_IPPanel': 'جت اقساط',
				'JetAqsaat': 'جت اقساط',
				'MelliPayamak': 'ملی پیامک',
				'KaveNegar': 'کاوه نگار',
				'IPPanel': 'IPPanel',
				'Bale': 'پیام رسان بله',
			}
			return items[panel] || 'نامشخص'
		},
		statusColor(status) {
			let items = {
				'Pending': 'warning',
				'Delivered': 'success',
				'Failed': 'error',
			}
			return items[status] || 'grey'
		},
		statusIcon(status) {
			let items = {
				'Pending': 'mdi-timer-sand',
				'Delivered': 'mdi-check-circle',
				'Failed': 'mdi-close-circle',
			}
			return items[status] || 'mdi-exclamation'
		},
		showSmsMessage(text) {
			this.smsMessage = text
			this.smsMessageDialog = true
		},
		async resend(item) {
			if (await this.$refs.confirm.open(
				'توجه',
				'آیا از ارسال مجدد این پیامک مطمئن هستید؟',
			)) {
				this.rowLoading = item.id
				api.post(`${this.area}/appsms/ReSend/` + item.id, null)
					.then(response => {
						toast.success('پیامک ارسال شد.')
						this.loadData()
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.rowLoading = ''
					})
			}
		},
		refreshStatus(item) {
			this.rowLoading = item.id
			api.post(`${this.area}/appsms/CheckStatus/` + item.id, null)
				.then(response => {
					item.statusText = response
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(() => {
					this.rowLoading = ''
				})
		}
	},
}
</script>
<style scoped></style>